export default function initMarcasSlider() {
    const section = document.querySelector('.c-marcas');
    const mainSlider = document.querySelector('.js-marcas-main-slider');
    const navSlider = document.querySelector('.js-marcas-nav-slider');

    if (!mainSlider || !navSlider) return;

    const marcasNav = new Swiper(navSlider, {
        slidesPerView: 2.2,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true, 
        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 20,
            }
        },
    });

    const marcasMain = new Swiper(mainSlider, {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoHeight: true,
        pagination: {
            el: '.c-marcas__progress',
            type: 'progressbar',
        },
        thumbs: {
            swiper: marcasNav
        },
        a11y: {
            prevSlideMessage: 'Marca anterior',
            nextSlideMessage: 'Próxima marca',
        }
    });

    const scrollToSection = () => {
        if (!section) return;
        const rect = section.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetY = rect.top + scrollTop - 50;

        window.scrollTo({
            top: targetY,
            behavior: 'smooth'
        });
    };

    marcasMain.on('slideChange', scrollToSection);

    marcasNav.on('click', scrollToSection);
}